import { BackgroundColors, BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const ProductStatusWrapper = styled.div`
	padding: 16px 24px;
	margin: 20px 0;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	border: 1px solid ${BorderColors.Secondary_primary};
	border-radius: ${BorderRadius.XL}px;
	background-color: ${BackgroundColors.BrandUtility50};
`;

export { ProductStatusWrapper };
